module.exports = __webpack_public_path__ + "static/media/thumbnail.4459538a.jpg";